import type { V2 } from './vec';

/** One-tick button edges. `pressed`/`released` are true for exactly one tick (edge-latched). */
export interface ButtonState {
  held: boolean;
  pressed: boolean;
  released: boolean;
}

export const buttonUp = (): ButtonState => ({ held: false, pressed: false, released: false });

/**
 * The sim never sees devices — input sources produce one TickInput per fixed tick.
 * `move` is already camera-relative, deadzone-rescaled, |move| ≤ 1.
 */
export interface TickInput {
  move: V2;
  jump: ButtonState;
  roll: ButtonState;
  /**
   * Sprint intent. A MULTIPLIER on top speed, not a bigger `move` — `|move| <= 1` is assumed
   * everywhere downstream (motion clamps it with `Math.min(1, ...)`), so the only way to ask for
   * more than full deflection is a separate channel.
   *
   * It exists because the keyboard is binary where a stick is analog: a pad already expresses
   * walk-vs-run through stick magnitude, so sprint is how a key reaches PAST what the stick's
   * full deflection means. Only `held` is read; there is no edge behaviour to latch.
   */
  sprint: ButtonState;
}

export const idleInput = (): TickInput => ({
  move: { x: 0, y: 0 },
  jump: buttonUp(),
  roll: buttonUp(),
  sprint: buttonUp(),
});
